module.exports = "../dist/frontend/icons/letters/a-gold.svg?85fa296706be4949de627093d08cbaa8";